import React from "react";
import "./style.css";

/**
 * @typedef {Object} BankingDetails
 * @property {string} bankName
 * @property {string} accountName
 * @property {string} accountNumber
 * @property {string} routingNumber
 * @property {string} swiftCode
 */

/**
 * @param {{
 * 	data: BankingDetails,
 * 	onChange: (data: BankingDetails) => void
 * }} props
 */
export default function BankingDetailsForm({ data, onChange }) {
	const handleChange = (field, value) => {
		onChange({ ...data, [field]: value });
	};

	return (
		<div className="invoice-section">
			<h3 className="invoice-section-title">Banking Details</h3>

			<div className="banking-grid">
				<div className="field">
					<label className="label" htmlFor="bank-name">
						Bank Name
					</label>
					<input
						id="bank-name"
						className="invoice-input"
						type="text"
						placeholder="First National Bank"
						value={data.bankName || ""}
						onChange={(e) => handleChange("bankName", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="account-name">
						Account Name
					</label>
					<input
						id="account-name"
						className="invoice-input"
						type="text"
						placeholder="Your Company Name"
						value={data.accountName || ""}
						onChange={(e) => handleChange("accountName", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="account-number">
						Account Number
					</label>
					<input
						id="account-number"
						className="invoice-input"
						type="text"
						inputMode="numeric"
						placeholder="1234567890"
						value={data.accountNumber || ""}
						onChange={(e) => handleChange("accountNumber", e.target.value)}
					/>
				</div>

				<div className="field">
					<label className="label" htmlFor="routing-number">
						Routing / BSB Number
					</label>
					<input
						id="routing-number"
						className="invoice-input"
						type="text"
						placeholder="123-456"
						value={data.routingNumber || ""}
						onChange={(e) => handleChange("routingNumber", e.target.value)}
					/>
				</div>

				<div className="field field--full">
					<label className="label" htmlFor="swift-code">
						SWIFT / BIC Code (International)
					</label>
					<input
						id="swift-code"
						className="invoice-input"
						type="text"
						placeholder="FNBAUS33"
						value={data.swiftCode || ""}
						onChange={(e) => handleChange("swiftCode", e.target.value)}
					/>
				</div>
			</div>
		</div>
	);
}
